import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { motion } from 'framer-motion';

const RedirectModal = ({
    show,
    handleClose,
    handleConfirm,
    title,
    messageLabel,
    targetUrl = "",
    variant = "external" // 'official', 'external', 'application'
}) => {

    const variantConfig = {
        official: {
            themeColor: 'var(--neon-gold)',
            defaultTitle: 'OFFICIAL CHANNEL',
            defaultMessage: 'You are navigating to a verified TNRP page.',
            iconGlow: '0 0 30px rgba(255, 215, 0, 0.2)'
        },
        external: {
            themeColor: 'var(--neon-cyan)',
            defaultTitle: 'EXTERNAL REDIRECT',
            defaultMessage: 'You are about to be redirected to an external site:',
            iconGlow: '0 0 30px rgba(0, 243, 255, 0.2)'
        },
        application: {
            themeColor: 'var(--neon-pink)',
            defaultTitle: 'OPENING APPLICATION',
            defaultMessage: 'This action will open an external application:',
            iconGlow: '0 0 30px rgba(188, 19, 254, 0.2)'
        }
    };

    const config = variantConfig[variant] || variantConfig.external;
    const displayTitle = title || config.defaultTitle;
    const displayMessage = messageLabel || config.defaultMessage;

    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            backdrop="static"
            keyboard={false}
            contentClassName="bg-transparent border-0"
        >
            <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                className="neon-card p-0 overflow-hidden"
                style={{
                    background: 'rgba(10, 10, 15, 0.95)',
                    border: `1px solid ${config.themeColor}`,
                    boxShadow: config.iconGlow
                }}
            >
                <div className="p-4 text-center">
                    <h4 className="mb-3" style={{ fontFamily: 'Orbitron, sans-serif', color: config.themeColor, textShadow: `0 0 10px ${config.themeColor}` }}>
                        {displayTitle}
                    </h4>
                    <p className="text-secondary mb-4">
                        {displayMessage}
                        <br />
                        <span className="text-white fw-bold">{targetUrl}</span>
                    </p>
                    <div className="d-flex justify-content-center gap-3">
                        <Button
                            variant="outline-light"
                            onClick={handleClose}
                            className="px-4 rounded-0"
                        >
                            CANCEL
                        </Button>
                        <Button
                            className="px-4 text-black fw-bold"
                            onClick={handleConfirm}
                            style={{
                                background: config.themeColor,
                                border: `1px solid ${config.themeColor}`,
                                boxShadow: `0 0 15px ${config.themeColor}`
                            }}
                        >
                            PROCEED
                        </Button>
                    </div>
                </div>
            </motion.div>
        </Modal>
    );
};

export default RedirectModal;
